export const cardStyles = (theme) => ({
  maxWidth: 500,
  minHeight: 300, 
  margin: "auto",
  padding: { xs: 2, sm: 3 },
  borderRadius: 3,
  boxShadow: 3,
  backgroundColor: "rgba(0, 0, 0, 0.1)",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
});

export const cardContentStyles = {
  textAlign: "center",
  padding: { xs: 2, sm: 3 },
  flexGrow: 1, 
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
};
  export const titleStyles = (theme) => ({
    fontSize: { xs: "1.5rem", sm: "2rem", md: "2.2rem" },
    lineHeight: 1.2,
    marginBottom: 2,
    color: theme.palette.mode === "light" ? "#000" : "#fff", 
  });
  
  export const subtitleStyles = (theme) => ({
    fontSize: { xs: "1.1rem", sm: "1.3rem", md: "1.4rem" },
    lineHeight: 1.4,
    marginBottom: 1,
    color: theme.palette.mode === "light" ? "#000" : "#fff", // Цвет текста для разных тем
  });
  
  export const priceStyles = (theme) => ({
    fontSize: { xs: "1.3rem", sm: "1.5rem", md: "1.6rem" },
    lineHeight: 1.4,
    color: theme.palette.mode === "light" ? "primary.main" : "#ffca28", // Цвет цены для разных тем
    marginBottom: 2,
  });
  
  export const weightStyles = (theme) => ({
    fontSize: { xs: "1.1rem", sm: "1.3rem", md: "1.4rem" },
    lineHeight: 1.4,
    color: theme.palette.mode === "light" ? "#000" : "#fff", // Цвет текста для разных тем
  });
  